






















































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Document, Driver } from "@/services/index.defs";
import { ValidationRules } from "_P/validate";
import LanguageControl from "_P/LanguageControl";
@Component({
    components: {}
})
export default class PersonDriverLicense extends Vue {
    @Prop() driver: Driver;

    Rules = ValidationRules;
    LanguageControls = LanguageControl;
    prevDriverLicense = false;

    oldDriverLicenseNumber = this.driver?.oldDriverLicense?.number ?? "";
    oldDriverLicenseSeria = this.driver?.oldDriverLicense?.seria ?? "";
    oldSurname = this.driver.oldSurname ?? "";
    @Watch("prevDriverLicense") controlPrevDriverLicense(value) {
        if (!value) {
            this.oldDriverLicenseNumber = this.driver.oldDriverLicense.number;
            this.oldDriverLicenseSeria = this.driver.oldDriverLicense.seria;
            this.oldSurname = this.driver.oldSurname;
            this.driver.oldDriverLicense = null;
            this.driver.oldSurname = "";
        } else {
            this.driver.oldDriverLicense = new Document({ docTypeId: 1 });
            this.driver.oldDriverLicense.number = this.oldDriverLicenseNumber;
            this.driver.oldDriverLicense.seria = this.oldDriverLicenseSeria;
            this.driver.oldSurname = this.oldSurname;
        }
    }
    created() {
        if (this.prevSeriesNumberInputText) this.prevDriverLicense = true;
    }
    get seriesNumberInputText(): string {
        let driverLicense = this.driver.driverLicense.seria;
        if (this.driver.driverLicense.seria.length == 4) {
            driverLicense += " ";
        }

        driverLicense += this.driver.driverLicense.number;
        return driverLicense;
    }
    set seriesNumberInputText(val) {
        val = val.replaceAllSubs(" ", "");
        this.driver.driverLicense.seria = val.substring(0, 4);
        this.driver.driverLicense.number = val.substring(4);
    }

    get prevSeriesNumberInputText(): string {
        let oldDriverLicense = this.driver.oldDriverLicense.seria;
        if (this.driver.oldDriverLicense.seria.length == 4) {
            oldDriverLicense += " ";
        }

        oldDriverLicense += this.driver.oldDriverLicense.number;
        return oldDriverLicense;
    }
    set prevSeriesNumberInputText(val) {
        val = val.replaceAllSubs(" ", "");
        this.driver.oldDriverLicense.seria = val.substring(0, 4);
        this.driver.oldDriverLicense.number = val.substring(4);
    }

    isYearDate: boolean = false;
    year: number = null;

    clearYearField() {
        if (this.isYearDate) {
            this.year = null;
        }
    }

    @Watch("year")
    onYearChanged(val) {
        if (val && !isNaN(val) && val <= new Date().getFullYear())
            this.driver.firstLicenseDate = new Date(val, 11, 31);
    }
}
